// extracted by mini-css-extract-plugin
export default {"tableHead":"UserGroupsList_tableHead__VC5+Y","tableBodyRow":"UserGroupsList_tableBodyRow__HttEV"};